import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

const renderStatus = (label: string, status: string) => {
  let statusColor = { color: "", background: "" };

  if (status === "pending") {
    statusColor = { color: "#FF8652", background: "rgba(255, 134, 82, 0.1)" };
  }

  if (status === "open") {
    statusColor = { color: "#2858D3", background: "rgba(40, 88, 211, 0.1)" };
  }

  if (status === "replied") {
    statusColor = { color: "#3EB458", background: "rgba(62, 180, 88, 0.1)" };
  }

  if (status === "closed") {
    statusColor = { color: "#A0A5B1", background: "rgba(160, 165, 177, 0.1)" };
  }

  return (
    <Chip
      label={label}
      sx={{
        textTransform: "uppercase",
        ...statusColor,
      }}
    />
  );
};

const ChatIssueTableRows = ({
  reportsTicketsData,
}: {
  reportsTicketsData: any;
}) => {
  const navigate = useNavigate();

  const handleRedirectTickets = (topic: any) => {
    // navigate("/tickets");
    const stateObj = {
      pageType: "mainReportPage",
      topic: topic,
    };
    navigate(`/view-tickets/${topic}`, { state: stateObj });
  };

  const handleRedirectTicketDetails = () => {
    navigate(`/tickets-details/${12345}`);
  };

  const renderStatusCount = (data: any, type: any) => {
    let count = 0;

    if (data && data.statusCounts && data.statusCounts.length > 0) {
      const resp = data.statusCounts.filter((e: any) => e.status == type);
      if (resp && resp.length > 0) {
        count = resp[0].ticketCount;
      }

      // data.statusCounts.map((type: any) => {
      //   if (type.status == "open") {
      //     count = type.ticketCount;
      //   }
      // });
      return count;
    }
  };
  const convertToTopic = (url: any) => {
    const parts = url.split("/");
    const valueAfterLastSlash = parts[parts.length - 1];
    return valueAfterLastSlash.replace(/-/g, " ");
  };
  const convertToDate = (data: any) => {
    const date = new Date(data);
    // Extract the components of the date (month, day, year)
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const day = date.getDate();
    const year = date.getFullYear();
    // Format the date as mm-dd-yyyy
    return day + "-" + month + "-" + year;
  };
  const renderArticleName = (articleName: any) => {
    if (articleName == "") return "-";

    const pattern1 =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    const str1 = articleName.replace(
      pattern1,
      "<a style='color:#1b66e6;word-wrap: break-word;' target='_blank' href='$1'>$1</a>"
    );
    const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    const str2 = str1.replace(
      pattern2,
      '$1<a style="color:#1b66e6;word-wrap: break-word;"  target="_blank" href="https://$2">https://$2</a>'
    );
    let htmlData = str2;
    const inputString = str2.toString();
    if (isHTMLTag(inputString)) {
      htmlData = str2;
    } else {
      htmlData = str2 + " (You cannot download this file)";
    }

    return (
      <div
        style={{ color: "cadetblue" }}
        dangerouslySetInnerHTML={{
          __html: htmlData,
        }}
      ></div>
    );
  };
  function isHTMLTag(str: any) {
    try {
      const doc = new DOMParser().parseFromString(
        `<body>${str}</body>`,
        "text/html"
      );
      const firstChild = doc.body.firstChild;
      return firstChild !== null && firstChild.nodeType === 1; // Node.ELEMENT_NODE
    } catch (error) {
      return false;
    }
  }

  return (
    <TableRow>
      <TableCell
        sx={
          {
            // cursor: "pointer",
          }
        }
        // onClick={handleRedirectTicketDetails}
      >
        <Typography
          sx={{
            textTransform: "capitalize",
            fontWeight: 500,
            fontSize: "0.8rem",
          }}
        >
          {/* {convertToTopic(reportsTicketsData?.articles[0]?.article_name || "-")} */}
          {reportsTicketsData?.articles[0]?.article_title || "-"}
        </Typography>

        <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: 400,
            fontSize: "0.8rem",
          }}
        >
          {renderArticleName(
            reportsTicketsData?.articles[0]?.article_name || ""
          )}
          {/* <a
            target="_blank"
            href={reportsTicketsData?.articles[0]?.article_name || "-"}
          >
            {reportsTicketsData?.articles[0]?.article_name || "-"}
          </a> */}
        </Typography>
        <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: 400,
            fontSize: "0.8rem",
          }}
        >
          Last updated date:&nbsp;
          {convertToDate(
            reportsTicketsData?.articles[0]?.last_updated_date || "-"
          )}
        </Typography>
        {/* <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.5)",
            fontWeight: 400,
            fontSize: "0.8rem",
          }}
        >
          Total Tickets: {reportsTicketsData.totalTicketCount}
        </Typography> */}
      </TableCell>
      {/* <TableCell align="center">{renderStatus("open", "open")}</TableCell>
      <TableCell align="center">{renderStatus("replied", "replied")}</TableCell>
      <TableCell align="center">{renderStatus("closed", "closed")}</TableCell> */}

      {/* <TableCell align="center">
        <Typography
          sx={{
            color: "#2858D3",
            fontWeight: 700,
            fontSize: "14px",
          }}
        >
          98
        </Typography>
        {renderStatusCount(reportsTicketsData, "replied")}
      </TableCell> */}
      {/* <TableCell align="center">
        <Typography
          sx={{
            color: "#2858D3",
            fontWeight: 700,
            fontSize: "14px",
          }}
        >
          98
        </Typography>
        {renderStatusCount(reportsTicketsData, "replied")}
      </TableCell> */}
      <TableCell align="center">
        <Avatar
          sx={{
            fontSize: "11px",
            background: "#2858D3",
            display: "inline-flex",
            border: "1px solid #FFF",
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 700,
              fontSize: "14px",
            }}
          >
            {reportsTicketsData.count}
          </Typography>
        </Avatar>

        {/* {renderStatusCount(reportsTicketsData, "replied")} */}
      </TableCell>
    </TableRow>
  );
};

export default ChatIssueTableRows;
